import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { HomeComponent } from './home/home.component';
import { PoliticaPrivacidadeComponent } from './politica-privacidade/politica-privacidade.component';

export const routes: Routes = [

  {
    path: '', 
    canActivate: [MsalGuard], 
    runGuardsAndResolvers: 'always',
    children: [

      {
        path: '',
        redirectTo: 'inicio',
        pathMatch: 'full'
      },

      {
        path: 'inicio',
        component: HomeComponent,
        children: [

          {
            path: '',
            redirectTo: 'agenda',
            pathMatch: 'full'
          },

          {
            path: 'politica-privacidade',
            component: PoliticaPrivacidadeComponent
          },

          {
            path: 'agenda',
            canMatch: [MsalGuard], // Protege o download do bundle
            loadChildren: () =>
              import('./schedule/_agenda-module/agenda.routes')
                .then(m => m.AGENDA_ROUTES)
          },

          {
            path: 'matriz',
            canMatch: [MsalGuard], // Protege o download do bundle
            loadChildren: () =>
              import('./matrix/_matriz-module/matriz.routes')
                .then(m => m.MATRIZ_ROUTES)
          },

          {
            path: 'reproducao',
            canMatch: [MsalGuard], // Protege o download do bundle
            loadChildren: () =>
              import('./reproduction/_reproducao-module/reproducao.routes')
                .then(m => m.REPRODUCAO_ROUTES)
          },

          {
            path: 'dashboard',
            canMatch: [MsalGuard], // Protege o download do bundle
            loadChildren: () =>
              import('./dashboard/_dashboard-module/dashboard.routes')
                .then(m => m.DASHBOARD_ROUTES)
          },

          {
            path: 'analises',
            canMatch: [MsalGuard], // Protege o download do bundle
            loadChildren: () =>
              import('./analises/_analises-module/analises.routes')
                .then(m => m.ANALISES_ROUTES)
          },

          {
            path: 'taxa-concepcao',
            canMatch: [MsalGuard], // Protege o download do bundle
            loadChildren: () =>
              import('./taxa-concepcao/_taxa-concepcao-module/taxa-concepcao.routes')
                .then(m => m.TAXA_CONCEPCAO_ROUTES)
          },

          {
            path: 'configuracao',
            canMatch: [MsalGuard], // Protege o download do bundle
            loadChildren: () =>
              import('./configurations/_configuracoes-module/configuracoes.routes')
                .then(m => m.CONFIGURACOES_ROUTES)
          },

          {
            path: 'listagem',
            canMatch: [MsalGuard], // Protege o download do bundle
            loadChildren: () =>
              import('./listing/_listagem-module/listagem.routes')
                .then(m => m.LISTAGEM_ROUTES)
          },

          {
            path: 'alta-cria',
            canMatch: [MsalGuard], // Protege o download do bundle
            loadChildren: () =>
              import('./alta-cria/_alta-cria-module/alta-cria.routes')
                .then(m => m.ALTA_CRIA_ROUTES)
          },

          {
            path: 'producao',
            canMatch: [MsalGuard], // Protege o download do bundle
            loadChildren: () =>
              import('./production/_producao-module/producao.routes')
                .then(m => m.PRODUCAO_ROUTES)
          },

          {
            path: 'ficha-individual',
            canMatch: [MsalGuard], // Protege o download do bundle
            loadChildren: () =>
              import('./ficha-individual/_ficha-individual-module/ficha-individual.routes')
                .then(m => m.FICHA_INDIVIDUAL_ROUTES)
          },

          {
            path: 'simulador-reproducao',
            canMatch: [MsalGuard], // Protege o download do bundle
            loadChildren: () =>
              import('./simulador-reproducao/_simulador-reproducao-module/simulador-reproducao.routes')
                .then(m => m.SIMULADOR_REPRODUCAO_ROUTES)
          },

          {
            path: 'benchmarking',
            canMatch: [MsalGuard], // Protege o download do bundle
            loadChildren: () =>
              import('./benchmarking/_benchmarking-module/benchmarking.routes')
                .then(m => m.BENCHMARKING_ROUTES)
          },

          {
            path: 'cadastro',
            canMatch: [MsalGuard], // Protege o download do bundle
            loadChildren: () =>
              import('./cadastro/_cadastro-module/cadastro.routes')
                .then(m => m.CADASTRO_ROUTES)
          },

          {
            path: 'relatorio',
            canMatch: [MsalGuard], // Protege o download do bundle
            loadChildren: () =>
              import('./relatorios/_relatorios-module/relatorios.routes')
                .then(m => m.RELATORIOS_ROUTES)
          },

          {
            path: 'importacao',
            canMatch: [MsalGuard], // Protege o download do bundle
            loadChildren: () =>
              import('./importacoes/_importacoes-module/importacoes.routes')
                .then(m => m.IMPORTACOES_ROUTES)
          }
        ]
      },
    ]
  },
  {
    path: '**',
    redirectTo: 'inicio'
  }
];